import React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import JasonFile from "./formLangfields.json";
import { Microphone, Stop, Pause, ArrowClockwise, Record } from 'phosphor-react';
import { Link } from 'react-router-dom';
import useRecorder from "../utils/useRecorder";
import { Dropdown } from 'react-bootstrap';
import { ApiCall } from '../../src/apicall';

function AddNewScheme() {
  const navigate = useNavigate();
  const [langsCo, setlangsCo] = useState();
  const [newScheme, setNewScheme] = useState();
  const [newDescription, setDescription] = useState();
  const [contPerson, setContPerson] = useState();
  const [contNumber, setContNumber] = useState();
  const [file, setFiles] = useState();
  const [website, setWebsite] = useState();
  const [newFile, setFile] = useState();
  const [recorderName, setRecorderName] = useState();
  const [audioURL, isRecording, startRecording, stopRecording, pause, setPause, resume, setResume, setIsRecording, setReset] = useRecorder();

  useEffect(() => {
    const langsCode = localStorage.getItem('selectedLang')
    if (langsCode) {
      setlangsCo(langsCode)
    } else {
      setlangsCo("en-IN")
    }
  }, []);

  const PageReset = () => {
    navigate(0);
  }

  React.useEffect(() => {
    const fetchText = async () => {
      let fileName = `aud.wav`;
      let fd = new FormData();
      const output = await axios({
        method: 'get',
        url: audioURL,
        responseType: 'blob'
      });
      let files = new File([output.data], fileName, { type: "audio/wav" });
      fd.append("file", files);
      fd.append("language", langsCo)

      axios.post('https://voiceapi.aicte-india.org/voice-to-text', fd)
        .then(async res => {
          const textResponse = res.data
          if (recorderName == 'schemeName') {
            setNewScheme(textResponse.data);
          }
          else if (recorderName == 'schemeContPerson') {
            setContPerson(textResponse.data);
          }
          else if (recorderName == 'newDescription') {
            setDescription(textResponse.data);
          }
          else if (recorderName == 'schemeContNumber') {
            setContNumber(textResponse.data)
          }
          else if (recorderName == 'schemeWebsite') {
            setWebsite(textResponse.data);
          }
        })
    };
    if (audioURL !== undefined) {
      fetchText();
    }
  }, [audioURL]);

  const NewScheme = (event) => {
    if (/^[a-zA-Z ]*$/.test(event.target.value) == false) {
      event.target.value = "";
    } else {
      setNewScheme(event.target.value)
    }
  }

  const ContPerson = (event) => {
    if (/^[a-zA-Z ]*$/.test(event.target.value) === false) {
      event.target.value = "";
    } else {
      setContPerson(event.target.value)
    }
  }

  const ContNumber = (value) => {
    if (value > 9999999999) {
      return '';
    } else {
      setContNumber(value)
    }
  }

  const Website = (value) => {
    setWebsite(value)
  }

  const SubmitHandler = (e) => {
    e.preventDefault();
    let config = {
      'Content-Type': 'application/json',
    };
    if (newScheme == undefined || newDescription == undefined || contPerson == undefined || contNumber == undefined || website == undefined) {
      alert('All fields are required')
    } else {
      let formData = new FormData();
      formData.append('file', newFile);
      formData.append('name', newScheme);
      formData.append('address', contPerson);
      formData.append('mobile', contNumber);
      formData.append('email', website);
      formData.append('defaultLanguage', langsCo);
      formData.append('body', newDescription);

      ApiCall('post', 'mkb-user-registration', config, formData)
        .then(function (response) {
          if (response.status == "success") {
            navigate('/mkb100');
          } else {
            alert("Something went wrong!")
          }
        });
    }
  };

  return (
    <>
      <div className="ui large breadcrumb">
        <Link to="https://anuvadini.aicte-india.org/" className="section">Home</Link> <span>/</span>
        <i className="right chevron icon divider"></i>
        <Link to="https://anuvadini.aicte-india.org/mkb100" className="section">Maan ki Baat</Link>
        <i className="right chevron icon divider"></i> <span>/</span>
        <div className="active section">Form Page</div>
      </div>

      <div className='container mt-3 p-0'>
        <div className='d-flex justify-content-between pl-0 align-items-center'>
          <a className='startbutton p-0' onClick={() => { navigate('/mkb100/') }}>Back</a>

          <Dropdown className='text-end'>
            <Dropdown.Toggle className='selectmenu text-start p-relative'>{JasonFile[4][langsCo]}</Dropdown.Toggle>
            <Dropdown.Menu>
              {Object.entries(JasonFile[4]).map((res, i) => {
                return (
                  <Dropdown.Item value={res[0]} onClick={(e) => { setlangsCo(res[0]); localStorage.setItem('selectedLang', res[0]); }} key={i}>{res[1]}</Dropdown.Item>
                )
              }
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className='container mt-4 content pb-4 mb-5'>
        <div className='row'>
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3">
            <label>{JasonFile[13][langsCo]} (Only png, jpeg and jpg file allowed)</label>
            <input type="file" name='file' className="form-control" accept="image/png, image/gif, image/jpeg" value={file} onChange={(e) => setFile(e.target.files[0])} />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-3 position-r">
            <label>{JasonFile[14][langsCo]}<spam className="redSpam">*</spam></label>
            <textarea type="textarea" value={newDescription} onChange={(event) => setDescription(event.target.value)} className="form-control"></textarea>
            <div className='fromGroup schema quill'>
              {isRecording && recorderName == 'newDescription' ?
                <React.Fragment>
                  <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                    <Stop size={32} weight="fill" />
                  </button>
                  {pause != false ?
                    <>
                      <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                      <button className="stopbutton startbutton" onClick={() => { setContNumber(""); }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                    </>
                    :
                    <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                      {Text ? <button className="stopbutton startbutton" onClick={() => { setContNumber(""); }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                    </>
                  }
                </React.Fragment>
                :
                <button className="startbutton" onClick={e => { startRecording(); setContNumber(""); setRecorderName('newDescription') }} disabled={isRecording}>
                  <Microphone size={20} weight="fill" />
                </button>
              }
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3 position-r">

            <label>{JasonFile[8][langsCo]}<spam className="redSpam">*</spam></label>
            <input type="text" className="form-control" value={newScheme} onChange={(event) => NewScheme(event)} required />
            <div className='fromGroup'>
              {isRecording && recorderName == 'schemeName' ?
                <React.Fragment>
                  <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                    <Stop size={32} weight="fill" />
                  </button>
                  {pause != false ?
                    <>
                      <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                      <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                    </>
                    :
                    <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                      {Text ? <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                    </>
                  }
                </React.Fragment>
                :
                <button className="startbutton" onClick={e => { setRecorderName('schemeName'); startRecording();; }} disabled={isRecording}>
                  <Microphone size={20} weight="fill" />
                </button>
              }
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3 position-r">
            <label>{JasonFile[9][langsCo]}<spam className="redSpam">*</spam></label>
            <input type="text" className="form-control" value={contPerson} onChange={(event) => ContPerson(event)} required />
            <div className='fromGroup'>
              {isRecording && recorderName == 'schemeContPerson' ?
                <React.Fragment>
                  <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                    <Stop size={32} weight="fill" />
                  </button>
                  {pause != false ?
                    <>
                      <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                      <button className="stopbutton startbutton" onClick={() => { setContPerson(""); }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                    </>
                    :
                    <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                      {Text ? <button className="stopbutton startbutton" onClick={() => { setContPerson(""); }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                    </>
                  }
                </React.Fragment>
                :
                <button className="startbutton" onClick={e => { startRecording(); setContPerson(""); setRecorderName('schemeContPerson') }} disabled={isRecording}>
                  <Microphone size={20} weight="fill" />
                </button>
              }
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3 position-r">
            <label>{JasonFile[10][langsCo]}</label>
            <input type="number" className="form-control" value={contNumber} onChange={(event) => ContNumber(event.target.value)} required />
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3 position-r">
            <label>{JasonFile[11][langsCo]}</label>
            <input type="email" className="form-control" value={website} onChange={(event) => Website(event.target.value)} required />
          </div>

          <div className="text-center">
            <button type="submit" className="btn btn-success w-auto mr-3" onClick={SubmitHandler}> {JasonFile[20][langsCo]}</button>
            <button type="submit" className="btn btn-danger w-auto" onClick={PageReset}> {JasonFile[21][langsCo]}</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddNewScheme;

